import isNumber from 'lodash/isNumber';
import React, {Component} from 'react';


function useOffset() {
  return window.ionic && window.ionic.Platform.isWebView() && !(window.ionic.Platform.isAndroid() && !window.ionic.Platform.isFullScreen);
}

export function IonKeyboardAttach(WrappedComponent) {
  return class IonKeyboardAttach extends Component {
    constructor(props) {
      super(props);

      this.state = {
        keyboardHeight: 0,
      };
      this.handleShow = this.handleShow.bind(this);
      this.handleHide = this.handleHide.bind(this);
    }

    handleShow(e) {
      this.setState({
        keyboardHeight: e.keyboardHeight || (e.detail && e.detail.keyboardHeight),
      });
    }

    handleHide() {
      this.setState({
        keyboardHeight: 0,
      });
    }

    render() {
      return (
        <WrappedComponent {...this.props} keyboardHeight={this.state.keyboardHeight} />
      );
    }

    componentDidMount() {
      if (useOffset()) {
        this.watchKeyboard = true;
        window.ionic.on('native.keyboardshow', this.handleShow, window);
        window.ionic.on('native.keyboardhide', this.handleHide, window);

        //deprecated
        window.ionic.on('native.showkeyboard', this.handleShow, window);
        window.ionic.on('native.hidekeyboard', this.handleHide, window);

      } else if (isNumber(this.props.keyboardHeight)) {
        // Support mocking in storybook
        this.setState({
          keyboardHeight: this.props.keyboardHeight,
        });
      }
    }

    componentWillUnmount() {
      if (this.watchKeyboard) {
        window.ionic.off('native.keyboardshow', this.handleShow, window);
        window.ionic.off('native.keyboardhide', this.handleHide, window);

        //deprecated
        window.ionic.off('native.showkeyboard', this.handleShow, window);
        window.ionic.off('native.hidekeyboard', this.handleHide, window);
      }
    }
  };
}

export default IonKeyboardAttach;



// WEBPACK FOOTER //
// ./src/js/_libs/reactionic/src/components/ionKeyboardAttach.js